<div class="dm-app" [class.sidebar-open]="sidebarOpen">

  <!-- Barra superiore -->
  <header class="dm-topbar">
    <button type="button" class="dm-icon-btn dm-menu-btn" (click)="sidebarOpen = !sidebarOpen"
            [attr.aria-label]="'documents.tab_chats' | translate" [attr.aria-expanded]="sidebarOpen">
      <i-tabler [name]="sidebarOpen ? 'x' : 'menu-2'" class="icon-20"></i-tabler>
    </button>
    <img src="assets/images/logos/logo_dm_light.svg" alt="DM Manufacturing" class="dm-logo"/>
    <span class="dm-product-tag">{{ 'documents.ai_title' | translate }}</span>

    <div class="dm-topbar-actions">
      @if (canAdminister) {
        <button type="button" class="dm-chip-btn hide-sm" (click)="openDocumentsAdmin()">
          <i-tabler name="settings" class="icon-18"></i-tabler>
          <span>{{ 'admin.title' | translate }}</span>
        </button>
      }
      <button type="button" class="dm-chip-btn" [matMenuTriggerFor]="langMenu" [attr.aria-label]="'documents.language' | translate">
        <i-tabler name="world" class="icon-18"></i-tabler>
        <span>{{ currentLanguage | uppercase }}</span>
      </button>
      <mat-menu #langMenu="matMenu">
        @for (lang of languages; track lang.code) {
          <button mat-menu-item (click)="setLanguage(lang.code)">{{ lang.language }}</button>
        }
      </mat-menu>

      <button type="button" class="dm-avatar" [matMenuTriggerFor]="userMenu" [attr.aria-label]="'documents.account' | translate">
        {{ userInitials }}
      </button>
      <mat-menu #userMenu="matMenu">
        <div class="dm-user-info">
          <strong>{{ user?.name }} {{ user?.lastname }}</strong>
          <span>{{ user?.email }}</span>
        </div>
        @if (canAdminister) {
          <button mat-menu-item (click)="openAdmin()">
            <i-tabler name="settings" class="icon-18 m-r-8"></i-tabler>
            {{ 'admin.title' | translate }}
          </button>
        }
        <button mat-menu-item (click)="logout()">
          <i-tabler name="logout" class="icon-18 m-r-8"></i-tabler>
          {{ 'documents.logout' | translate }}
        </button>
      </mat-menu>
    </div>
  </header>

  <div class="dm-body">
    <div class="dm-scrim" (click)="sidebarOpen = false"></div>

    <!-- Conversazioni e documenti -->
    <aside class="dm-sidebar">
      <button type="button" class="dm-new-chat" (click)="newConversation()" [disabled]="sending">
        <i-tabler name="plus" class="icon-18"></i-tabler>{{ 'documents.new_conversation' | translate }}
      </button>

      <div class="dm-tabs" role="tablist">
        <button type="button" role="tab" [class.active]="tab === 'chats'" [attr.aria-selected]="tab === 'chats'" (click)="tab = 'chats'">
          {{ 'documents.tab_chats' | translate }}
        </button>
        <button type="button" role="tab" [class.active]="tab === 'docs'" [attr.aria-selected]="tab === 'docs'" (click)="tab = 'docs'">
          {{ 'documents.tab_docs' | translate }}
          <span class="dm-count">{{ readyDocuments.length }}</span>
        </button>
      </div>

      @if (tab === 'chats') {
        @if (sessions.length > 6) {
          <label class="dm-search">
            <i-tabler name="search" class="icon-16"></i-tabler>
            <input type="search" [(ngModel)]="sessionFilter" [placeholder]="'documents.search_chats' | translate"
                   [attr.aria-label]="'documents.search_chats' | translate"/>
          </label>
        }
        <nav class="dm-list" [attr.aria-label]="'documents.tab_chats' | translate">
          @if (sessionsLoaded && sessions.length === 0) {
            <p class="dm-empty-list">{{ 'documents.no_conversations' | translate }}</p>
          }
          @for (group of sessionGroups; track group.label) {
            <p class="dm-group-label">{{ group.label | translate }}</p>
            @for (session of group.items; track session.session_id) {
              <div class="dm-item" role="button" tabindex="0" [class.active]="isCurrent(session)"
                   (click)="openSession(session)" (keydown.enter)="openSession(session)">
                <span class="dm-item-body">
                  <span class="dm-item-title" [title]="session.title">{{ session.title || ('documents.untitled' | translate) }}</span>
                  <span class="dm-item-meta">
                    @if (session.scope_name) {
                      <i-tabler name="file-type-pdf" class="icon-12"></i-tabler>{{ session.scope_name }} ·
                    }
                    {{ session.updated_at | date:'dd/MM/yy, HH:mm' }}
                  </span>
                </span>
                <button type="button" class="dm-item-action" (click)="deleteSession(session, $event)"
                        [matTooltip]="'documents.delete_chat' | translate" [attr.aria-label]="'documents.delete_chat' | translate">
                  <i-tabler name="trash" class="icon-16"></i-tabler>
                </button>
              </div>
            }
          }
          @if (sessionFilter && sessionGroups.length === 0) {
            <p class="dm-empty-list">{{ 'admin.no_results' | translate }}</p>
          }
        </nav>
      } @else {
        <nav class="dm-list" [attr.aria-label]="'documents.tab_docs' | translate">
          @if (documents.length > 0) {
            <div class="dm-item dm-doc" role="button" tabindex="0" [class.active]="current.scope === null"
                 (click)="selectScope(null)" (keydown.enter)="selectScope(null)">
              <span class="dm-doc-icon all"><i-tabler name="stack-2" class="icon-18"></i-tabler></span>
              <span class="dm-item-body">
                <span class="dm-item-title">{{ 'documents.all_documents' | translate }}</span>
                <span class="dm-item-meta">{{ 'documents.all_documents_hint' | translate }}</span>
              </span>
            </div>
          }
          @if (listLoaded && documents.length === 0) {
            <p class="dm-empty-list">{{ (canAdminister ? 'documents.empty_manager' : 'documents.empty_employee') | translate }}</p>
          }
          @for (doc of documents; track doc.uuid) {
            <div class="dm-item dm-doc" role="button" tabindex="0" [class.active]="current.scope === doc.uuid"
                 [class.disabled]="!isReady(doc)" (click)="selectScope(doc.uuid!)" (keydown.enter)="selectScope(doc.uuid!)">
              <span class="dm-doc-icon"><i-tabler name="file-type-pdf" class="icon-18"></i-tabler></span>
              <span class="dm-item-body">
                <span class="dm-item-title" [title]="doc.name">{{ doc.name }}</span>
                <span class="dm-item-meta">
                  @switch (doc.rag_status) {
                    @case (RagStatus.ANALYZED) {
                      <span class="dm-dot ready"></span>{{ 'documents.status_ready' | translate }}
                    }
                    @case (RagStatus.PENDING) {
                      <span class="dm-dot pending"></span>{{ 'documents.status_pending' | translate }}
                    }
                    @case (RagStatus.ERROR) {
                      <span class="dm-dot error"></span>{{ 'documents.status_unavailable' | translate }}
                    }
                    @default {
                      <span class="dm-dot"></span>{{ 'documents.status_not_indexed' | translate }}
                    }
                  }
                  @if (formatSize(doc['dimension_file'])) { · {{ formatSize(doc['dimension_file']) }} }
                </span>
              </span>
              <button type="button" class="dm-item-action visible" (click)="openPdf(doc, undefined, $event)"
                      [matTooltip]="'documents.open_pdf' | translate" [attr.aria-label]="'documents.open_pdf' | translate">
                <i-tabler name="external-link" class="icon-16"></i-tabler>
              </button>
            </div>
          }
        </nav>
        @if (canAdminister) {
          <button type="button" class="dm-manage" (click)="openDocumentsAdmin()">
            <i-tabler name="settings" class="icon-16"></i-tabler>{{ 'documents.manage_documents' | translate }}
          </button>
        }
      }
    </aside>

    <!-- Assistente -->
    <main class="dm-chat">
      <div class="dm-chat-head">
        <span class="dm-scope">
          <i-tabler [name]="current.scope ? 'file-type-pdf' : 'stack-2'" class="icon-16"></i-tabler>
          {{ 'documents.scope_label' | translate }}
          <strong>{{ selectedDocument ? selectedDocument.name : ('documents.all_documents' | translate) }}</strong>
        </span>
        @if (current.scope) {
          <button type="button" class="dm-link-btn" (click)="selectScope(null)">{{ 'documents.all_documents' | translate }}</button>
        }
      </div>

      <div class="dm-messages" #messagesContainer>
        <div class="dm-thread">
          @if (messages.length === 0) {
            <div class="dm-welcome">
              <span class="dm-orb"><i-tabler name="sparkles" class="icon-28"></i-tabler></span>
              @if (loadingConversation) {
                <mat-spinner diameter="28"></mat-spinner>
              } @else if (listLoaded && readyDocuments.length === 0 && !hasPendingDocuments) {
                <h1>{{ 'documents.welcome_title' | translate }}</h1>
                <p>{{ (canAdminister ? 'documents.welcome_empty_manager' : 'documents.welcome_empty_employee') | translate }}</p>
                @if (canAdminister) {
                  <button type="button" class="dm-primary-btn" (click)="openDocumentsAdmin()">
                    <i-tabler name="upload" class="icon-18"></i-tabler>{{ 'documents.manage_documents' | translate }}
                  </button>
                }
              } @else if (!canChat && current.scope) {
                <h1>{{ 'documents.doc_unavailable_title' | translate }}</h1>
                <p>{{ 'documents.doc_unavailable_hint' | translate }}</p>
              } @else if (!canChat) {
                <h1>{{ 'documents.indexing_title' | translate }}</h1>
                <p>{{ 'documents.wait_hint' | translate }}</p>
              } @else {
                <h1>{{ 'documents.ask_title' | translate }}</h1>
                <p>{{ 'documents.ask_hint' | translate }}</p>
                <div class="dm-suggestions">
                  @for (s of suggestions; track s) {
                    <button type="button" (click)="useSuggestion(s)">
                      <i-tabler name="message-question" class="icon-16"></i-tabler>{{ s | translate }}
                    </button>
                  }
                </div>
              }
            </div>
          }

          @for (msg of messages; track $index) {
            <div class="dm-msg" [class.user]="msg.role === 'user'" [class.bot]="msg.role === 'bot'" [class.error]="msg.error">
              @if (msg.role === 'bot') {
                <span class="dm-msg-avatar"><i-tabler name="sparkles" class="icon-16"></i-tabler></span>
              }
              <div class="dm-msg-content">
                @if (msg.html) {
                  <div class="dm-msg-bubble dm-rich" [innerHTML]="msg.html" (click)="onAnswerClick($event, msg)"></div>
                } @else {
                  <div class="dm-msg-bubble">{{ msg.text }}</div>
                }
                @if (msg.sources?.length) {
                  <div class="dm-sources">
                    <span class="dm-sources-label">{{ 'documents.sources' | translate }}</span>
                    <ol>
                      @for (src of msg.sources; track src.index) {
                        <li class="dm-source" [class.unavailable]="!src.available"
                            [matTooltip]="src.available ? '' : ('documents.source_unavailable' | translate)">
                          <span class="dm-source-index">{{ src.index }}</span>
                          <span class="dm-source-name" [title]="src.name">{{ src.name }}</span>
                          @for (r of src.ranges; track r.from) {
                            <button type="button" (click)="openSource(src, r.from)" [disabled]="!src.available"
                                    [matTooltip]="src.available ? ('documents.open_page' | translate) : ''">
                              {{ 'documents.pages' | translate }} {{ r.from }}@if (r.to > r.from) {–{{ r.to }}}
                            </button>
                          }
                          @if (!src.available) {
                            <em>{{ 'documents.source_unavailable_short' | translate }}</em>
                          }
                        </li>
                      }
                    </ol>
                  </div>
                }
                <div class="dm-msg-footer">
                  <span>{{ msg.timestamp | date:'HH:mm' }}</span>
                  @if (msg.role === 'bot' && !msg.error) {
                    <button type="button" class="dm-msg-action" (click)="copyAnswer(msg)">
                      <i-tabler [name]="msg.copied ? 'check' : 'copy'" class="icon-14"></i-tabler>
                      {{ (msg.copied ? 'documents.copied' : 'documents.copy') | translate }}
                    </button>
                  }
                </div>
              </div>
            </div>
          }

          @if (sending) {
            <div class="dm-msg bot">
              <span class="dm-msg-avatar"><i-tabler name="sparkles" class="icon-16"></i-tabler></span>
              <div class="dm-msg-content">
                <div class="dm-msg-bubble dm-typing">
                  <span></span><span></span><span></span>
                  <em>{{ 'documents.thinking' | translate }}</em>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="dm-composer-wrap">
        <div class="dm-composer" [class.disabled]="!canChat">
          <textarea
            #chatInput
            [(ngModel)]="inputText"
            (input)="autoGrowInput()"
            (keydown.enter)="onEnterKey($event)"
            [placeholder]="(canChat ? 'documents.placeholder' : 'documents.placeholder_disabled') | translate"
            [disabled]="sending || !canChat"
            rows="1"
            autocomplete="off"></textarea>
          <button type="button" class="dm-send" (click)="sendMessage()"
                  [disabled]="sending || !canChat || !inputText.trim()" [attr.aria-label]="'documents.send' | translate">
            <i-tabler name="arrow-up" class="icon-20"></i-tabler>
          </button>
        </div>
        <p class="dm-disclaimer">{{ 'documents.disclaimer' | translate }}</p>
      </div>
    </main>
  </div>
</div>
